import { Toast } from 'vant';

export const baseUrl = '/eservice/knowledgeExternal';

export const cepBaseUrl = '/FHH/EM1HESERVICE2/eservice/knowledge';
Toast.setDefaultOptions({
  forbidClick: true,
});

export class LoadConfig {
  constructor({
    needLoading = true,
    needError = true,
    needSuccess = false,
    loadingMsg = $t('加载中...'),
    errorMsg = '',
    successMsg = '',
  } = {}) {
    this.needLoading = needLoading;
    this.needError = needError;
    this.needSuccess = needSuccess;
    this.loadingMsg = loadingMsg;
    this.errorMsg = errorMsg;
    this.successMsg = successMsg;
  }

  loading() {
    if (!this.needLoading) {
      return;
    }
    this.$loading = Toast.loading({
      duration: 0,
      message: this.loadingMsg,
    });
    // loading是单例，所以要记录调用了几次 等所以接口都返回数据后再清除loading
    this.$loading._count ? (this.$loading._count += 1) : (this.$loading._count = 1);
  }

  fail(msg) {
    this._beforeResult();
    if (!this.needError) {
      return;
    }
    Toast.fail({
      duration: 1000,
      message: this.errorMsg || msg,
    });
  }

  success(msg) {
    this._beforeResult();
    if (!this.needSuccess) {
      return;
    }
    Toast.success({
      duration: 1000,
      message: this.successMsg || msg,
    });
  }

  clearLoading() {
    if (!this.$loading) {
      return;
    }
    this.$loading._count--;
    if (this.$loading._count <= 0) {
      this.$loading && this.$loading.clear();
      this.$loading._count = 0;
    }
  }
  _beforeResult() {
    this.needLoading && this.clearLoading();
  }
}
